type Translate = (key: string) => string

const featureTranslationKeys: Record<string, string> = {
  'All Basic features plus the following': 'subscription_dialog_all_basic_features',
  'All Basic features and the following': 'subscription_dialog_all_basic_features',
  'Automated Archiving': 'subscription_dialog_archiving',
  'Archiving': 'subscription_dialog_archiving',
  'Geolocation of Device & Lock/Unlock': 'subscription_dialog_geolocation_lock',
  'Geolocation of Device & Lock unlock': 'subscription_dialog_geolocation_lock',
  'Geolocation and Lock Unlock': 'subscription_dialog_geolocation_lock',
  'Analysis of Organisation and Job Metrics': 'subscription_dialog_analytics_metrics',
  'Analysis of Organisation and job Metrics': 'subscription_dialog_analytics_metrics',
  'Analytics and Metrics': 'subscription_dialog_analytics_metrics',
  'Smart Flag (Suspicious Results Filter)': 'subscription_dialog_smart_flag_filter',
  'Smart Flag (AKA Suspicious results filter)': 'subscription_dialog_smart_flag_filter',
  'Smart Flag Filter': 'subscription_dialog_smart_flag_filter',
  'AnyWARE Landing Page': 'subscription_feature_landing_page',
  'Book services/repair via AnyWARE': 'subscription_feature_book_services',
  'Book services/repair via AnyWARE (linked to the CRM)': 'subscription_feature_book_services',
  'TeamViewer Link': 'subscription_feature_teamviewer_link',
  'TeamViewer link': 'subscription_feature_teamviewer_link',
  'Health Check Status': 'subscription_feature_health_check_status',
  'Health Check Status LanTEK IV – S&L PLA Tip Wear Detector': 'subscription_feature_health_check_status',
  'Generate QR Code Label': 'subscription_feature_qr_code_label',
  'PoE Derating via AnyWARE': 'subscription_feature_poe_derating',
  'Fiber Loss Calculator': 'subscription_feature_fiber_loss_calculator',
  'Link Budget Calculator': 'subscription_feature_link_budget_calculator',
  'Multimode Bandwidth Calculator': 'subscription_feature_multimode_bandwidth_calculator',
}

export const translateSubscriptionFeature = (feature: string, translate: Translate): string => {
  const translationKey = getSubscriptionFeatureTranslationKey(feature)
  return translationKey ? translate(translationKey) : feature
}

export const getSubscriptionFeatureTranslationKey = (feature: string): string | undefined =>
  featureTranslationKeys[feature]
